import ApiService from '../../util/api';

export const ActionTypes = {
  REQUEST_INVITATION_ACCOUNT: 'zola/cards/invitation_account/request',
  RECEIVE_INVITATION_ACCOUNT: 'zola/cards/invitation_account/receive',
};

function requestInvitationAccount() {
  return {
    type: ActionTypes.REQUEST_INVITATION_ACCOUNT,
  };
}

function receiveInvitationAccount(json) {
  console.log('received invitations account', json);
  return {
    type: ActionTypes.RECEIVE_INVITATION_ACCOUNT,
    payload: {
      account: json
    }
  };
}

export function fetchInvitationAccount() {
  return (dispatch) => {
    dispatch(requestInvitationAccount());
    return ApiService.get('/web-api/v1/invitation-account')
      .then(json => dispatch(receiveInvitationAccount(json)));
  };
}

export function createInvitationAccount() {
  return dispatch => (
    ApiService.post('/web-api/v1/invitation-account')
      .then(json => dispatch(receiveInvitationAccount(json)))
  );
}



// WEBPACK FOOTER //
// ./src/cards/actions/invitationAccountActions.js